import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

var _window, _window$location;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { toHostnameEnv } from '@peloton/env-hostnames/toHostnameEnv';
import { toMatchingTld, SupportedTLD as TLD } from '@peloton/internationalize/models/locale';
import { oneLineTrim } from '@peloton/text/oneLine';
var curHostname = typeof window !== 'undefined' ? (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname : undefined;
var hostnameEnv = curHostname ? toHostnameEnv(curHostname) : undefined;
var uatSubdomain = (hostnameEnv === null || hostnameEnv === void 0 ? void 0 : hostnameEnv.type) === 'uat' ? hostnameEnv === null || hostnameEnv === void 0 ? void 0 : hostnameEnv.subdomain : 'uat';

var stageN = function stageN() {
  var match;

  if (curHostname) {
    match = /--api-core-(.*)--stage/.exec(curHostname);
  }

  if (match && match[1]) {
    return match[1];
  } //default to stage 2


  return '2';
};

export var LinkEnvs = {
  Local: 'local-www',
  Prod: 'www',
  Qa1: 'qa1-www',
  Qa2: 'qa2-www',
  UatQa: "www.".concat(uatSubdomain),
  UatProd: 'uat-prod-www',
  StageN: "www--api-core-".concat(stageN(), "--stage.").concat(uatSubdomain)
};
export var DigitalLinkEnvs = {
  Local: 'local-members',
  UatProd: "members.".concat(uatSubdomain),
  UatQa: "members.".concat(uatSubdomain),
  UatLitProd: "members--lit.".concat(uatSubdomain),
  UatLitQa: "members--lit-api-qa.".concat(uatSubdomain),
  StgProd: 'stg-members',
  StgQa: "members.".concat(uatSubdomain),
  StageN: "members--api-core-".concat(stageN(), "--stage.").concat(uatSubdomain),
  Prod: 'members'
};
export var withDigitalUatPrefix = function withDigitalUatPrefix(linkEnv) {
  try {
    var matches = /^([a-z\d\-_]*)--members/.exec(window.location.hostname);
    return Array.isArray(matches) && matches.length ? [matches[1], linkEnv].join('--') // this is a lie
    : linkEnv;
  } catch (_) {
    return linkEnv;
  }
};
export var ApiEnvs;

(function (ApiEnvs) {
  ApiEnvs["Qa1"] = "qa1";
  ApiEnvs["Qa2"] = "qa2";
  ApiEnvs["Prod"] = "api";
  ApiEnvs["Local"] = "local-api";
  ApiEnvs["Test"] = "localhost";
})(ApiEnvs || (ApiEnvs = {}));

export var isK8s = function isK8s(apiEnv) {
  return apiEnv.endsWith('k8s');
};
export var getApiCluster = function getApiCluster(env) {
  if (env === ApiEnvs.Prod) {
    return 'prod';
  } else if (env === ApiEnvs.Qa1) {
    return 'stage';
  } else if (env === ApiEnvs.Qa2) {
    return 'test';
  } else if (env === ApiEnvs.Local) {
    return 'stage';
  } else {
    var _env$split$reverse = env.split('.').reverse(),
        _env$split$reverse2 = _slicedToArray(_env$split$reverse, 2),
        cluster = _env$split$reverse2[1];

    return cluster;
  }
}; // k8s uses pelotime in dev/test, and onepeloton in stage/prod

export var isPelotimeK8s = function isPelotimeK8s(apiEnv) {
  return isK8s(apiEnv) && ['dev', 'test'].includes(getApiCluster(apiEnv));
};
export var isCustomApiEnv = function isCustomApiEnv(apiEnv) {
  return !Object.values(ApiEnvs).some(function (v) {
    return v === apiEnv;
  });
};
export var PreorderLinkEnvs;

(function (PreorderLinkEnvs) {
  PreorderLinkEnvs["Uat"] = "uat-preorder";
  PreorderLinkEnvs["Stg"] = "stg-preorder";
  PreorderLinkEnvs["Prod"] = "preorder";
})(PreorderLinkEnvs || (PreorderLinkEnvs = {}));

export var StudioLinkEnvs = {
  Local: 'local-studio',
  Prod: 'studio',
  Staging: "studio--lit.".concat(uatSubdomain),
  UatQa: "studio.".concat(uatSubdomain)
};
export var HomecomingLinkEnvs;

(function (HomecomingLinkEnvs) {
  HomecomingLinkEnvs["Prod"] = "homecoming";
  HomecomingLinkEnvs["Dev"] = "homecoming-dev";
})(HomecomingLinkEnvs || (HomecomingLinkEnvs = {}));

export var AccountLinkEnvs = {
  Local: 'local-account',
  Prod: 'account',
  UatQa: "account.".concat(uatSubdomain),
  UatProd: "account--api.".concat(uatSubdomain),
  StageN: "account--api-core-".concat(stageN(), "--stage.").concat(uatSubdomain)
};
export var AuthLinkEnvs = {
  Local: 'local-auth',
  Prod: 'auth',
  UatQa: "auth.test",
  UatProd: "auth.test",
  StageN: "auth.test"
};
export var BookingLinkEnvs;

(function (BookingLinkEnvs) {
  BookingLinkEnvs["Local"] = "book-staging";
  BookingLinkEnvs["Prod"] = "booking";
  BookingLinkEnvs["Staging"] = "book-staging";
  BookingLinkEnvs["UatQa"] = "book-staging";
  BookingLinkEnvs["UatProd"] = "book-staging";
})(BookingLinkEnvs || (BookingLinkEnvs = {}));

export var isExtLink = function isExtLink(link, extLinkEnv) {
  return 'type' in link && (link.type in extLinkEnv && 'path' in link || link.type === 'social' && 'href' in link);
};
export var toExtLinkEnv = function toExtLinkEnv() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread({
    api: ApiEnvs.Prod,
    blog: 'blog',
    boutique: 'boutique',
    commercial: 'commercial',
    digital: DigitalLinkEnvs.Prod,
    ecomm: LinkEnvs.Prod,
    findyourride: 'findyourride',
    global: 'global',
    hostname: typeof window !== 'undefined' && window && window.location && window.location.hostname ? window.location.hostname : 'onepeloton.com',
    house: 'house',
    homecoming: HomecomingLinkEnvs.Prod,
    internal: 'internal',
    preorder: PreorderLinkEnvs.Prod,
    support: 'support',
    studio: StudioLinkEnvs.Prod,
    www: LinkEnvs.Prod,
    booking: BookingLinkEnvs.Prod,
    hospitality: 'hospitality',
    milestone: 'investor',
    account: AccountLinkEnvs.Prod,
    auth: AuthLinkEnvs.Prod,
    press: 'press'
  }, opts);
};
export var toBookingLinkEnv = function toBookingLinkEnv(_ref) {
  var isProd = _ref.isProd,
      isStaging = _ref.isStaging,
      isLocal = _ref.isLocal,
      isUatProd = _ref.isUatProd;
  return isProd && BookingLinkEnvs.Prod || isStaging && BookingLinkEnvs.Staging || isLocal && BookingLinkEnvs.Local || isUatProd && BookingLinkEnvs.UatProd || BookingLinkEnvs.UatQa;
};
export var toPeloLink = function toPeloLink(type, path) {
  var hostnameOverrides = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    type: type,
    path: path,
    hostnameOverrides: hostnameOverrides
  };
};
export var toSocialLink = function toSocialLink(href) {
  return {
    type: 'social',
    href: href
  };
};
export var toApiLink = function toApiLink(path) {
  var _toPeloLink;

  return toPeloLink('api', path, (_toPeloLink = {}, _defineProperty(_toPeloLink, TLD.CoUk, toPreservedNonPelotimeK8sTld), _defineProperty(_toPeloLink, TLD.Ca, toPreservedNonPelotimeK8sTld), _defineProperty(_toPeloLink, TLD.De, toPreservedNonPelotimeK8sTld), _defineProperty(_toPeloLink, TLD.Au, toPreservedNonPelotimeK8sTld), _toPeloLink));
}; // Convenience methods

export var toWWWLink = function toWWWLink(path) {
  var _toPeloLink2;

  return toPeloLink('www', path, (_toPeloLink2 = {}, _defineProperty(_toPeloLink2, TLD.CoUk, toPreservedTld), _defineProperty(_toPeloLink2, TLD.Ca, toPreservedTld), _defineProperty(_toPeloLink2, TLD.De, toPreservedTld), _defineProperty(_toPeloLink2, TLD.Au, toPreservedTld), _toPeloLink2));
};
export var toPressLink = function toPressLink(path) {
  var _toPeloLink3;

  return toPeloLink('press', path, (_toPeloLink3 = {}, _defineProperty(_toPeloLink3, TLD.CoUk, toPreservedTld), _defineProperty(_toPeloLink3, TLD.Ca, toPreservedTld), _defineProperty(_toPeloLink3, TLD.De, toPreservedTld), _defineProperty(_toPeloLink3, TLD.Au, toPreservedTld), _toPeloLink3));
};
export var toEcommLink = function toEcommLink(path) {
  var _toPeloLink4;

  return toPeloLink('ecomm', path, (_toPeloLink4 = {}, _defineProperty(_toPeloLink4, TLD.CoUk, toPreservedTld), _defineProperty(_toPeloLink4, TLD.Ca, toPreservedTld), _defineProperty(_toPeloLink4, TLD.De, toPreservedTld), _defineProperty(_toPeloLink4, TLD.Au, toPreservedTld), _toPeloLink4));
};
export var toDigitalLink = function toDigitalLink(path) {
  var _toPeloLink5;

  return toPeloLink('digital', path, (_toPeloLink5 = {}, _defineProperty(_toPeloLink5, TLD.CoUk, toPreservedTld), _defineProperty(_toPeloLink5, TLD.Ca, toPreservedTld), _defineProperty(_toPeloLink5, TLD.De, toPreservedTld), _defineProperty(_toPeloLink5, TLD.Au, toPreservedTld), _toPeloLink5));
};
export var toStudioLink = function toStudioLink(path) {
  var _toPeloLink6;

  return toPeloLink('studio', path, (_toPeloLink6 = {}, _defineProperty(_toPeloLink6, TLD.CoUk, toPreservedTld), _defineProperty(_toPeloLink6, TLD.Ca, toPreservedTld), _defineProperty(_toPeloLink6, TLD.De, toPreservedTld), _defineProperty(_toPeloLink6, TLD.Au, toPreservedTld), _toPeloLink6));
};
export var toCommercialLink = function toCommercialLink(path) {
  var _toPeloLink7;

  return toPeloLink('commercial', path, (_toPeloLink7 = {}, _defineProperty(_toPeloLink7, TLD.CoUk, toPreservedTld), _defineProperty(_toPeloLink7, TLD.Ca, toPreservedTld), _defineProperty(_toPeloLink7, TLD.De, toPreservedTld), _defineProperty(_toPeloLink7, TLD.Au, toPreservedTld), _toPeloLink7));
};
export var toAccountLink = function toAccountLink(path) {
  var _toPeloLink8;

  return toPeloLink('account', path, (_toPeloLink8 = {}, _defineProperty(_toPeloLink8, TLD.CoUk, toPreservedTld), _defineProperty(_toPeloLink8, TLD.Ca, toPreservedTld), _defineProperty(_toPeloLink8, TLD.De, toPreservedTld), _defineProperty(_toPeloLink8, TLD.Au, toPreservedTld), _toPeloLink8));
};
export var toAuthLink = function toAuthLink(path) {
  return toPeloLink('auth', path);
};
export var toHomecomingLink = function toHomecomingLink(path) {
  return toPeloLink('homecoming', path, {});
};
export var toSupportLink = function toSupportLink(path) {
  var _toPeloLink9;

  return toPeloLink('support', path, (_toPeloLink9 = {}, _defineProperty(_toPeloLink9, TLD.Com, toLocalizedSupportLink('en-us')), _defineProperty(_toPeloLink9, TLD.CoUk, toLocalizedSupportLink('en-gb')), _defineProperty(_toPeloLink9, TLD.Ca, toLocalizedSupportLink('en-ca')), _defineProperty(_toPeloLink9, TLD.De, toLocalizedSupportLink('de')), _defineProperty(_toPeloLink9, TLD.Au, toLocalizedSupportLink('en-au')), _toPeloLink9));
};

var toLocalizedSupportLink = function toLocalizedSupportLink(locale) {
  return function (link, env, hostname) {
    return link.path === '/' ? toPreservedTld(link, env, hostname) : "support.onepeloton.com/hc/".concat(locale);
  };
};

export var toBookingLink = function toBookingLink() {
  var _toPeloLink10;

  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var queryString = "/?location=".concat(location.replace(/ /g, '-').toLowerCase());
  return toPeloLink('booking', location ? queryString : '/', (_toPeloLink10 = {}, _defineProperty(_toPeloLink10, TLD.Ca, toPreservedTld), _defineProperty(_toPeloLink10, TLD.CoUk, toPreservedTld), _defineProperty(_toPeloLink10, TLD.De, toPreservedTld), _defineProperty(_toPeloLink10, TLD.Au, toPreservedTld), _toPeloLink10));
};
export var toBoutiqueLink = function toBoutiqueLink(path) {
  var _toPeloLink11;

  return toPeloLink('boutique', path, (_toPeloLink11 = {}, _defineProperty(_toPeloLink11, TLD.Ca, function () {
    return 'apparel.onepeloton.ca';
  }), _defineProperty(_toPeloLink11, TLD.CoUk, function () {
    return 'apparel.onepeloton.co.uk';
  }), _defineProperty(_toPeloLink11, TLD.De, function () {
    return 'apparel.onepeloton.de';
  }), _defineProperty(_toPeloLink11, TLD.Au, function () {
    return 'apparel.onepeloton.com.au';
  }), _toPeloLink11));
};
export var toHref = function toHref(link, env, location) {
  if (link.type === 'social') {
    return toSocialHref(link); // Social links don't have environments.
  }

  return oneLineTrim("\n    ".concat(getProtocol(link, env), "\n    ").concat(getHost(link, env), "\n    ").concat(getPort(link, env, location), "\n    ").concat(link.path, "\n  "));
};
export var getUrlForTracking = function getUrlForTracking(link, extLinkEnv) {
  return toHref(link, extLinkEnv);
};

var getProtocol = function getProtocol(link, env) {
  return isLocalApi(link, env) || isLocalStudio(link, env) || isTestApi(link, env) ? 'http://' : 'https://';
};

var getEnv = function getEnv(link, env) {
  return env[link.type];
};

var getPort = function getPort(link, env, location) {
  if (isLocalWww(link, env) || isLocalStudio(link, env) || isLocalMembers(link, env) || isLocalAccount(link, env)) {
    return currentPortFormatted(location);
  } else if (isTestApi(link, env)) {
    return ":".concat(TEST_PORT);
  }

  return '';
};

var toPreservedTld = function toPreservedTld(link, env, hostname) {
  return "".concat(getEnv(link, env), ".").concat(toDomain(link, env)).concat(toMatchingTld(hostname));
};

var toPreservedNonPelotimeK8sTld = function toPreservedNonPelotimeK8sTld(link, env, hostname) {
  return isPelotimeK8s(env.api) ? "".concat(getEnv(link, env), ".").concat(toDomain(link, env), ".com") : toPreservedTld(link, env, hostname);
};

export var toDomain = function toDomain(link, env) {
  if (link.type === 'api' && env.api) {
    /* kubernetes deployments _always_ run on pelotime domains */
    return isPelotimeK8s(env.api) ? 'pelotime' : 'onepeloton';
  }

  return 'onepeloton';
};

var hasHostnameOverrides = function hasHostnameOverrides(link) {
  return Boolean(link.hostnameOverrides);
};

export var getHost = function getHost(link, env) {
  if (hasHostnameOverrides(link)) {
    var handler = link.hostnameOverrides[toMatchingTld(env.hostname)];

    if (handler) {
      return handler(link, env, env.hostname);
    }
  }

  return isTestApi(link, env) ? 'localhost' : "".concat(getEnv(link, env), ".").concat(toDomain(link, env), ".com");
};
export var currentPortFormatted = function currentPortFormatted() {
  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location;
  return (// TODO: add wwwPort field to ExtLinkEnv to pass port to toHref
    location.port !== '' ? ":".concat(location.port) : ''
  );
};

var isLocalApi = function isLocalApi(link, env) {
  return isApi(link) && env[link.type] === ApiEnvs.Local;
};

var isLocalWww = function isLocalWww(link, env) {
  return (link.type === 'www' || link.type === 'ecomm') && env.www === LinkEnvs.Local;
};

var isLocalStudio = function isLocalStudio(link, env) {
  return link.type === 'studio' && env.studio === StudioLinkEnvs.Local;
};

var isLocalMembers = function isLocalMembers(link, env) {
  return link.type === 'digital' && env.digital === DigitalLinkEnvs.Local;
};

var isLocalAccount = function isLocalAccount(link, env) {
  return link.type === 'account' && env.account === AccountLinkEnvs.Local;
};

var isTestApi = function isTestApi(link, env) {
  return isApi(link) && env[link.type] === ApiEnvs.Test;
};

var isApi = function isApi(link) {
  return link.type === 'api';
};

export var TEST_PORT = 8989;
export var toSocialHref = function toSocialHref(link) {
  return link.href;
};
export var safelyDecode = function safelyDecode(str) {
  try {
    return atob(str !== null && str !== void 0 ? str : '');
  } catch (_unused) {
    // invalid path
    return '';
  }
};